import { useEffect } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const useFetchRoles = () => {
  const { apiGet } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  useEffect(() => {
    const fetchData = async () => {
      startLoading();
      const response = await apiGet("/users/roles", "Error al obtener los roles de usuario");
      setResponse(response);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { data, error, loading };
};

export default useFetchRoles;
